import { useContext, useState } from "react"
import { formatDate, notify } from "../../utils/utils"
import { Fetch } from "../../services/api"
import { UserContext } from "../../context/provider/UserProvider";

const urlGestionConocimiento = process.env.REACT_APP_XPROJECT_API;
// const urlGestionConocimiento = 'http://192.168.2.10:3282/api' + "/Domain";
export const useGestionConocimientos = () => {
    const { stateUser } = useContext(UserContext);
    const estadoDefault = [
        {nomEstado: 'Activo', codEstado: 1},
        {nomEstado: 'Anulado', codEstado: 10}
    ];

    const detalleDominioDefault = {
        codGestionInfraestructuraDominio: 0,
        codigoDominio:"",
        nomDominio:"",
        expiracionDominio:"",
        expiracionSSL:"",
        nomSubDominio:"",
        nomProyecto:"",
        nomAplicacion:"",
        nomDocker:"",
        nomProveedorSSL:"",
        nomEstadoSSl:"",
        servidor:"",
        puerto:"",
        descripcionDominio:"",
        comentario:"",
        codUsuarioEdicion:0,
        codProveedorDominio:0,
        fechaCompra:"",
        fechaRenovacion:"",
        certificadoSSL: 0,
        codProveedorSSL: 0,
        codGestionInfraestructuraServidor: 0
    };

    const detalleSubDominioDefault = {
        codGestionInfraestructuraSubDominio: 0,
        nomSubDominio: "",
        codGestionInfraestructuraDominio: 0,
        fechaCreacion: "",
        certificadoSSL: false,
        expiracionSSL: "",
        codProveedorSSL: "",
        descripcion: "",
        codigoDominio: "",
    }

    const detalleServidorDefault = {
        codGestionInfraestructuraServidor: 0,
        nomServidor: "",
        codUbigeoDistrito: 0,
        codAmbienteTrabajo: 0,
        codTipoServidor: 0,
        comentario: "",
        modeloServidor: "",
        modeloCPU: "",
        numCPU: 0 ,
        capacidadMemoriaRAM: "",
        almacenamientoCPU: "",
        tarjetaRed: "",
        tarjetaVideo: "",
        net: "",
        subNET: "",
        ipPublica: "",
        ipPrivada: "",
        codTipoOS: 0,
        distribucion: "",
        version: "",
        licencia: "",
        urlAcceso: "",
        usuarioRoot: "",
        contrasenia: "",
        puertoRemoto: 0,
        codProtocoloRemoto: 0,
        fechaInstalacion: formatDate(new Date()),
        fechaUltimoMantenimiento: formatDate(new Date()),
    };

    const detalleServicioDefault = {
        codGestionInfraestructuraAplicacion: 0,
        codigoAplicacion: "",
        nomProyecto: "",
        nomAplicacion: "",
        codTipoAplicacion: 0,
        nomTipoAplicacion: "",
        versionActual: "",
        usuarioPrincipal: "",
        codLenguajeProgramacion: 0,
        nomLenguajeProgramacion: "",
        cuentaPropietario: "",
        repositorio: "",
        codTipoOS: 0,
        nomTipoOS: "",
        codPlataforma: 0,
        nomPlataforma: "",
        codFramework: 0,
        framework: "",
        versionFramework: "",
        nomServidor: "",
        localizacionArchivo: "",
        codGestionInfraestructuraServidor: 0,
        fechaUltimaActualizacion: "",
        descripcion: "",
        codEstado: 0,
        nomEstado: "",
        contacto: "",
        observaciones: "",
        urlAcceso: "",
        fechaAlta: "",
        codAmbienteTrabajo: 0,
        ambiente: "",
        nomDependencia: "",
        codDominioJerarquia: 0,
        codGestionInfraestructuraDomAux: 0,
        nomDomAux: "",
        documentacion: "",
        codMotorBaseDatos: 0,
        nomMotorBaseDatos: "",
        manualUsuario: "",
    };

    const detalleLeccionDefault = {
        codGestionConocimiento: 0,
        codigoConocimiento: 0,
        titulo: "",
        autor: "",
        fechaCreacion:"",
        codGestionInfraestructuraAplicacion: 0,
        nomProyecto: "",
        descripcionSituacion: "",
        descripcionSolucion: "",
        recomendacion: "",
        codCategoriaConocimiento: 0,
        nomCategoriaConocimiento: "",
        codImpacto: 0,
        impacto: "",
        documentacion: "",
        etiqueta: "",
        codEstado: 0,
        nomEstado: "",
        listaImagenesLesson: [],
    }

    const detalleDocumentacionDefault = {
        codDocumentoTecnico: 0,
        titulo: "",
        autor: "",
        fechaCreacion: "",
        codGestionInfraestructuraAplicacion: 0,
        nomAplicacion: "",
        nomProyecto: "",
        nomDocumentoTecnicoTipo: "",
        codDocumentoTecnicoTipo: 0,
        nomNivelConfidencialidad: "",
        codNivelConfidencialidad: 0,
        urlDocumentacion: "",
        descripcion: "",
        observacion: "",
        etiqueta: "",
        fechaUltimaActualizacion: "",
        codEstado: 0,
        nomEstado: ""
    }

    const [ listaEstadoConocimiento, setListaEstadoConocimiento ] = useState(estadoDefault);
    const [ listaProveedorDominio, setListaProveedorDominio ] = useState([]);
    const [ listaProveedorSSL, setListaProveedorSSL ] = useState([]);
    const [ listaServidores, setListaServidores ] = useState([]);
    const [ listaNivelesImpacto, setListaNivelesImpacto ] = useState([]);
    const [ listaCategoriaConocimiento, setListaCategoriaConocimiento ] = useState([]);
    const [ listaServicio, setListaServicio ] = useState([]);
    const [ listDistritosLima, setListaDistritoLima ] = useState([]);
    const [ listaAmbienteTrabajo, setListalistaAmbienteTrabajo ] = useState([]);
    const [ listaTipoServidor , setListalistaTipoServidor ] = useState([]);
    const [ listaSistemaOperativo, setListalistaSistemaOperativo ] = useState([]);
    const [ listaProtocoloRemoto, setListaProcoloRemoto ] = useState([]);
    const [ listaDominios, setListaDominios ] = useState([]);
    const [ listaTipoDocumentacion, setListaTipoDocumentacion ] = useState([]);
    const [ listaNivelConfidencialidad, setListalistaNivelConfidencialidad ] = useState([]);
    const [ listaTipoServicios, setListalistaTipoServicios ] = useState([]);
    const [ listaLenguajeProgramacion, setListalistaLenguajeProgramacion ] = useState([]);
    const [ listaPlataformaDespliegue, setListalistaPlataformaDespliegue ] = useState([]);
    const [ listaFramework, setListaFramework ] = useState([])
    const [ listaMotorBD, setListaMotorBD ] = useState([]);
    const [ listaDominioSubDom, setListaDominioSubdDom ] = useState([]);

    const [ dominios, setDominios ] = useState([]);
    const [ subDominios, setSubDominios ] = useState([]);
    const [ servidores, setServidores ] = useState([]);
    const [ serviciosGeneral, setServiciosGeneral ] = useState([]);
    const [ lecciones, setLecciones ] = useState([]);
    const [ documentacionesTecnica, setDocumentacionTecnica ] = useState([]);

    const [ detalleDominio, setDetalleDominio ] = useState(detalleDominioDefault);
    const [ detalleSubDominio, setDetalleSubDominio ] = useState(detalleSubDominioDefault);
    const [ detalleServidor, setDetalleServidor ] = useState(detalleServidorDefault);
    const [ detalleServicio, setDetalleServicio ] = useState(detalleServicioDefault);
    const [ detalleLeccion, setDetalleLeccion ] = useState(detalleLeccionDefault);
    const [ detalleDocumentacion, setDetalleDocumentacion ] = useState(detalleDocumentacionDefault);

    const listarEstados = async () => {
        try{
            const response = await Fetch({
                url: urlGestionConocimiento + '/Domain/Lista_Filtra_Estado'
            });
            console.log('response -> ',response)
            !response.isValid && notify(response.exceptions[0].description)
            setListaEstadoConocimiento(response.isValid ? response.content : []);
        }
        catch(e){
            notify('Ocurrió un error en el servicio', 'error');
            setListaEstadoConocimiento(estadoDefault);
        }
    }

    const listarProveedorDominio = async () => {
        try
        {
            const response = await Fetch({
                url: urlGestionConocimiento + '/Domain/DomainProviders'
            });

            !response.isValid && notify(response.exceptions[0].description);
            setListaProveedorDominio(response.isValid ? response.content : []);
        }
        catch(e)
        {
            notify('Ocurrió un error en el servicio', 'error');
            setListaProveedorDominio([]);
        }
    }

    const listarProveedorSSL = async () => {
        try
        {
            const response = await Fetch({
                url: urlGestionConocimiento + '/Domain/SSLProviders'
            });

            !response.isValid && notify(response.exceptions[0].description);
            setListaProveedorSSL(response.isValid ? response.content : []);
        }
        catch(e)
        {
            console.log('Erro al listar proveedores: ',e)
            notify('Ocurrió un error en el servicio', 'error');
            setListaProveedorSSL([]);
        }
    }
    
    const listarNivelImpacto = async () => {
        try
        {
            const response = await Fetch({
                url: urlGestionConocimiento + '/General/ListImpactLevels' 
            })
            !response.isValid && notify(response.exceptions[0].description, 'error');
            setListaNivelesImpacto(response.isValid ? response.content : []);
        }
        catch(e)
        {
            console.log('Erro al listar niveles de impacto: ',e)
            notify('Ocurrió un error en el servicio', 'error');
            setListaNivelesImpacto([]);
        }
    }

    const listarCategoriaConocimiento = async() => {
        try
        {
            const response = await Fetch({
                url: urlGestionConocimiento + '/General/ListKnowledgeCategory' 
            })
            !response.isValid && notify(response.exceptions[0].description, 'error');
            setListaCategoriaConocimiento(response.isValid ? response.content : []);
        }
        catch(e)
        {
            console.log('Erro al listar niveles de impacto: ',e)
            notify('Ocurrió un error en el servicio', 'error');
            setListaCategoriaConocimiento([]);
        }
    }

    const listarServicios = async() => {
        try
        {
            const response = await Fetch({
                url: urlGestionConocimiento + '/Service/ListService' 
            })
            !response.isValid && notify(response.exceptions[0].description, 'error');
            setListaServicio(response.isValid ? response.content : []);
        }
        catch(e)
        {
            console.log('Error al listar combo de servicios: ',e)
            notify('Ocurrió un error en el servicio', 'error');
            setListaServicio([]);
        }
    }

    const listarTipoServidor = async() => {
        try
        {
            const response = await Fetch({
                url: urlGestionConocimiento + '/Server/ServerTypeList'
            })
            !response.isValid && notify(response.exceptions[0].description, 'error');
            setListalistaTipoServidor(response.isValid ? response.content : []);
        }
        catch(e)
        {
            console.log('Error al listar combo de servicios: ',e)
            notify('Ocurrió un error en el servicio', 'error');
            setListalistaTipoServidor([]);
        }
    }

    const listarDistritosLima = async () => {
        try
        {
            const response = await Fetch({url: urlGestionConocimiento + '/General/ListDistricts'});
            !response.isValid && notify(response.exceptions[0].description);
            setListaDistritoLima(response.isValid ? response.content.filter(item => item.codUbigeoDepartamentoSunat === "15") : []);
        }
        catch(e)
        {
            console.log('Error el listar distritos Lima: ',e)
            setListaDistritoLima([]);
            notify('Ocurrió un error en el servicio', 'error');
        }
    }

    const listarAmbienteTrabajo = async () => {
        try
        {
            const response = await Fetch({url: urlGestionConocimiento + '/General/ListWorkEnvironment'});
            !response.isValid && notify(response.exceptions[0].description);
            setListalistaAmbienteTrabajo(response.isValid ? response.content : []);
        }
        catch(e)
        {
            console.log('Error el listar distritos Lima: ',e)
            setListalistaAmbienteTrabajo([]);
            notify('Ocurrió un error en el servicio', 'error');
        }
    }

    const listarSistemaOperativo = async () => {
        try
        {
            const response = await Fetch({
                url: urlGestionConocimiento + '/General/ListOS'
            })
            !response.isValid && notify(response.exceptions[0].description, 'error');
            setListalistaSistemaOperativo(response.isValid ? response.content : []);
        }
        catch(e)
        {
            console.log('Error al listar combo de sistema operativo: ',e)
            notify('Ocurrió un error en el servicio', 'error');
            setListalistaSistemaOperativo([]);
        }
    }

    const listarProtocoloRemoto = async () => {
        try
        {
            const response = await Fetch({
                url: urlGestionConocimiento + '/Server/RemoteProtocolList'
            })
            !response.isValid && notify(response.exceptions[0].description, 'error');
            setListaProcoloRemoto(response.isValid ? response.content : []);
        }
        catch(e)
        {
            console.log('Error al listar combo de protocolo remoto: ',e)
            notify('Ocurrió un error en el servicio', 'error');
            setListaProcoloRemoto([]);
        }
    }

    const listarNivelConfidencialidad = async () => {
        try
        {
            const response = await Fetch({
                url: urlGestionConocimiento + '/TechnicalDocumentation/ConfidentiallyLevel'
            })
            !response.isValid && notify(response.exceptions[0].description, 'error');
            setListalistaNivelConfidencialidad(response.isValid ? response.content : []);
        }
        catch(e)
        {
            console.log('Error al listar combo de protocolo remoto: ',e)
            notify('Ocurrió un error en el servicio', 'error');
            setListalistaNivelConfidencialidad([]);
        }
    }

    const listarTipoServicios = async () => {
        try
        {
            const response = await Fetch({
                url: urlGestionConocimiento + '/Service/Type'
            })
            !response.isValid && notify(response.exceptions[0].description, 'error');
            setListalistaTipoServicios(response.isValid ? response.content : []);
        }
        catch(e)
        {
            console.log('Error al listar combo de servicios: ',e)
            notify('Ocurrió un error en el servicio', 'error');
            setListalistaTipoServicios([]);
        }
    }

    const listarLenguajeProgramacion = async () => {
        try
        {
            const response = await Fetch({
                url: urlGestionConocimiento + '/Service/ListProgrammingLanguaje'
            })
            !response.isValid && notify(response.exceptions[0].description, 'error');
            setListalistaLenguajeProgramacion(response.isValid ? response.content : []);
        }
        catch(e)
        {
            console.log('Error al listar combo de servicios: ',e)
            notify('Ocurrió un error en el servicio', 'error');
            setListalistaLenguajeProgramacion([]);
        }
    }
    
    const listarFramework = async () => {
        try {
            const response = await Fetch({
                url: urlGestionConocimiento + '/General/ListFramework'
            })
            !response.isValid && notify(response.exceptions[0].description, 'error');
            setListaFramework(response.isValid ? response.content : []);
            
        } catch (e) {
            console.log('Error al listar combo de servicios: ',e)
            notify('Ocurrió un error en el servicio', 'error');
            setListalistaLenguajeProgramacion([]);
            
        }
    }
    
    //////////////////////////////////////////////////////// END POINT PARA DOMINIOS //////////////////////////////////////////////////////////////////////

    const listarDominios = async (codEstado) => {
        try
        {
            const response = await Fetch({
                url: urlGestionConocimiento + '/Domain?' + new URLSearchParams({
                    CodEstado : codEstado
                })
            });
            !response.isValid && notify(response.exceptions[0].description);
            setDominios(response.isValid ? response.content : []);
        }
        catch(e)
        {
            setDominios([]);
            notify('Ocurrió un error en el servicio', 'error');
        }
    }

    const guadarEditarDominio = async () => {
        try
        {
            const esGuardar = detalleDominio.codGestionInfraestructuraDominio === 0 ? true : false;
            const response = await Fetch({
                url: urlGestionConocimiento + '/Domain',
                method: esGuardar ? 'POST' : 'PUT',
                body: JSON.stringify({
                    codUsuarioAccion: stateUser.codUsuario,
                    ...( !esGuardar ?
                        {
                            codGestionInfraestructuraDominio: detalleDominio.codGestionInfraestructuraDominio,
                        }
                        :
                        ''
                    ),
                    // codigoDominio: detalleDominio.codigoDominio,
                    nomDominio: detalleDominio.nomDominio,
                    codProveedorDominio: detalleDominio.codProveedorDominio,
                    codGestionInfraestructuraServidor: detalleDominio.codGestionInfraestructuraServidor,
                    fechaCompra: detalleDominio.fechaCompra,
                    fechaRenovacion: detalleDominio.fechaRenovacion,
                    codProveedorSSL: detalleDominio.codProveedorSSL,
                    expiracionSSL: detalleDominio.expiracionSSL ,
                    certificadoSSL: detalleDominio.certificadoSSL ,
                    descripcionDominio: detalleDominio.descripcionDominio
                })
            })
            notify((response.isValid ? response.content : response.exceptions[0].description) , response.isValid ? 'success' : 'error' )
            return response.isValid;
        }
        catch(e)
        {
            console.log('Error al guardar el dominio: ',e);
            notify('Ocurrió un error en el servicio', 'error');
            return false;
        }
    }

    const eliminarDominio = async () => {
        try
        {
            const response = await Fetch({
                url: urlGestionConocimiento,
                body: JSON.stringify({
                    
                })
            })
            notify((response.isValid ? response.content : response.exceptions[0].description) , response.isValid ? 'success' : 'error' )
            return response.isValid;
        }
        catch(e)
        {
            console.log('Erro al eliminar el dominio: ',e);
            notify('Ocurrió un error en el servicio', 'error');
            return false;
        }
    }

    const listarDetalleDominio = async (dominio) => {
        try
        {
            if(dominio)
            {
                setDetalleDominio({
                    codGestionInfraestructuraDominio: dominio.codGestionInfraestructuraDominio,
                    codGestionInfraestructuraServidor: dominio.codGestionInfraestructuraServidor,
                    codigoDominio: dominio.codigoDominio,
                    nomDominio: dominio.nomDominio ,
                    expiracionSSL: dominio.expiracionSSL ,
                    descripcionDominio: dominio.descripcionDominio ,
                    comentario: dominio.comentario ,
                    codProveedorDominio: dominio.codProveedorDominio ,
                    fechaCompra: dominio.fechaCompra ,
                    fechaRenovacion: dominio.fechaRenovacion ,
                    certificadoSSL: dominio.certificadoSSL ,
                    codProveedorSSL: dominio.codProveedorSSL,
                    nomProveedorSSL: dominio.nomProveedorSSL,
                    nomEstadoSSL: dominio.nomEstadoSSl,
                })
                return
            }
            setDetalleDominio(detalleDominioDefault);
            
        }
        catch(e)
        {
            notify('Ocurrió un error en el servicio', 'error');
            setDetalleDominio(detalleDominioDefault);
            console.log('Error al listar detalle servidor', e);
        }
    }

    const editarValorDominio = (key, value) => {
        setDetalleDominio(dominio => {
            return {
                ...dominio,
                [key]: value
            }
        })
    }

    const listarDominiosCombo = async () => {
        try
        {
            const response = await Fetch({ url: urlGestionConocimiento + '/Domain/DomainFilter' });
            !response.isValid && notify(response.exceptions[0].description);
            setListaDominios(response.isValid ? response.content : []);
        }
        catch(e)
        {
            setListaDominios([]);
            notify('Ocurrió un error en el servicio', 'error');
        }
    }

    //////////////////////////////////////////////////////// END POINT PARA SUB DOMINIOS //////////////////////////////////////////////////////////////////////

    const listarSubDominios = async (codEstado) => {
        try
        {
            const response = await Fetch({
                url: urlGestionConocimiento + '/SubDomain?' + new URLSearchParams({
                    CodEstado: codEstado
                })
            })
            !response.isValid && notify(response.exceptions[0].description, 'error')
            setSubDominios(response.isValid ? response.content : [])
        }
        catch(e)
        {
            setSubDominios([])
            notify('Ocurrió un error en el servicio','error');
            console.log('Error al listar sub dominios: ',e);
        }
    }

    const guardarEditarSubdominio = async () => {
        try
        {
            const esGuardar = detalleSubDominio.codGestionInfraestructuraSubDominio === 0 ? true : false;
            const response = await Fetch({
                url: urlGestionConocimiento + '/SubDomain',
                method: esGuardar ? 'POST' : 'PUT',
                body: JSON.stringify({
                    CodUsuarioAccion: stateUser.codUsuario,
                    ...( !esGuardar ?
                        {
                            CodGestionInfraestructuraSubDominio: detalleSubDominio.codGestionInfraestructuraSubDominio,
                        }
                        :
                        ''
                    ),
                    NomSubDominio: detalleSubDominio.nomSubDominio,
                    CodGestionInfraestructuraDominio: detalleSubDominio.codGestionInfraestructuraDominio,
                    FechaCreacion: detalleSubDominio.fechaCreacion,
                    CertificadoSSL: detalleSubDominio.certificadoSSL,
                    ExpiracionSSL: detalleSubDominio.expiracionSSL,
                    CodProveedorSSL:  detalleSubDominio.codProveedorSSL,
                    Descripcion: detalleSubDominio.descripcion
                })
            })
            notify((response.isValid ? response.content : response.exceptions[0].description), response.isValid ? 'success' : 'error');
            return response.isValid
        }
        catch(e)
        {
            notify('Ocurrió un error en el servicio','error');
            console.log('Error al guardar subdominio: ',e)
            return false;
        }
    }

    const eliminarSubDominio = async (codSub, motivoElimin) => {
        try
        {
            const response = await Fetch({
                url: urlGestionConocimiento + '/SubDomain',
                method: 'DELETE',
                body: JSON.stringify({
                    CodUsuarioAccion: stateUser.codUsuario,
                    CodGestionInfraestructuraSubDominio: codSub,
                    MotivoEliminacion: motivoElimin,
                })
            });

            !response.isValid && notify(response.exceptions[0].description, 'error');
            return response.isValid
        }
        catch(e){
            notify('Ocurrió un error en el servicio','error');
            console.log('Error al eliminar subdominio: ',e)
            return false;
        }
    }

    const listarDetalleSubDominio = async (subDominio) => {
        try
        {
            if(subDominio)
            {
                setDetalleSubDominio({
                    codGestionInfraestructuraSubDominio: subDominio.codGestionInfraestructuraSubDominio,
                    nomSubDominio: subDominio.nomSubDominio,
                    codGestionInfraestructuraDominio: subDominio.codGestionInfraestructuraDominio,
                    fechaCreacion: subDominio.fechaCreacion,
                    certificadoSSL: subDominio.certificadoSSL,
                    expiracionSSL: subDominio.expiracionSSL,
                    codProveedorSSL: subDominio.codProveedorSSL,
                    descripcion: subDominio.descripcion,
                    codigoDominio: subDominio.codigoDominio,
                })
                return
            }
            setDetalleSubDominio(detalleSubDominioDefault)

        }
        catch(e)
        {
            setDetalleSubDominio(detalleSubDominioDefault)
            notify('Ocurrió un error en el servicio','error');
            console.log('Error la listar detalle de subdominio: ',e)
        }
    }

    const editarValorSubDominio = (key, value) => {
        setDetalleSubDominio(subDom => {
            return {
                ...subDom,
                [key]: value
            }
        })
    }

    const listarDominioSubdominio = async () => {
        try{
            const response = await Fetch({ url: urlGestionConocimiento + '/Domain/SubDomainFilter' });
            !response.isValid && notify(response.exceptions[0].description, 'error')
            setListaDominioSubdDom(response.isValid ? response.content : []);
        }
        catch(e){
            console.log('Erro al listar dominio-subdominio: ',e)
            notify('Ocurrió un error en el servicio', 'error');
            setListaDominioSubdDom([]);
        }
    } 

    ///////////////////////////////////////////////////////  END POINT PARA SERVIDORES  //////////////////////////////////////////////////////////////////////

    const listarServidores = async () => {
        try{
            const response = await Fetch({ url: urlGestionConocimiento + '/Server' });
            !response.isValid && notify(response.exceptions[0].description, 'error')
            setServidores(response.isValid ? response.content : []);
        }
        catch(e){
            console.log('Erro al listar servidores: ',e)
            notify('Ocurrió un error en el servicio', 'error');
            setServidores([]);
        }
    }

    const listarDetalleServidor = async (servidor) => {
        try
        {
            if(servidor)
            {
                setDetalleServidor({
                    codGestionInfraestructuraServidor: servidor.codGestionInfraestructuraServidor,
                    codigoServidor: servidor.codigoServidor,
                    nomServidor: servidor.nomServidor,
                    codUbigeoDistrito: servidor.codUbigeoDistrito,
                    codAmbienteTrabajo: servidor.codAmbienteTrabajo,
                    codTipoServidor: servidor.codTipoServidor,
                    comentario: servidor.comentario,
                    modeloServidor: servidor.modeloServidor,
                    modeloCPU: servidor.modeloCPU,
                    numCPU: servidor.numCPU,
                    capacidadMemoriaRAM: servidor.capacidadMemoriaRAM,
                    almacenamientoCPU: servidor.almacenamientoCPU,
                    tarjetaRed: servidor.tarjetaRed,
                    tarjetaVideo: servidor.tarjetaVideo,
                    net: servidor.net,
                    subNET: servidor.subNET,
                    ipPublica: servidor.ipPublica,
                    ipPrivada: servidor.ipPrivada,
                    codTipoOS: servidor.codTipoOS,
                    distribucion: servidor.distribucion,
                    version: servidor.version,
                    licencia: servidor.licencia,
                    urlAcceso: servidor.urlAcceso,
                    usuarioRoot: servidor.usuarioRoot,
                    contrasenia: servidor.contrasenia,
                    puertoRemoto: servidor.puertoRemoto,
                    codProtocoloRemoto: servidor.codProtocoloRemoto,
                    fechaInstalacion: servidor.fechaInstalacion,
                    fechaUltimoMantenimiento: servidor.fechaUltimoMantenimiento
                })
                return
            }
            setDetalleServidor(detalleServidorDefault);
        }
        catch(e)
        {
            notify('Ocurrió un error en el servicio', 'error');
            setDetalleServidor(detalleServidorDefault);
            console.log('Error al listar detalle servidor', e);
        }
    }

    const guardarEditarServidor = async () => {
        try
        {
            const esGuardar = detalleServidor.codGestionInfraestructuraServidor === 0 ? true : false;
            const response = await Fetch({
                url: urlGestionConocimiento + '/Server',
                method: esGuardar ? 'POST' : 'PUT',
                body: JSON.stringify({
                    CodUsuarioAccion: stateUser.codUsuario,
                    ...(!esGuardar ?
                        { CodGestionInfraestructuraServidor: detalleServidor.codGestionInfraestructuraServidor}
                        : 
                        ''
                    ),
                    NomServidor: detalleServidor.nomServidor,
                    CodUbigeoDistrito: detalleServidor.codUbigeoDistrito,
                    CodAmbienteTrabajo: detalleServidor.codAmbienteTrabajo,
                    CodTipoServidor: detalleServidor.codTipoServidor,
                    Comentario: detalleServidor.comentario,
                    ModeloServidor: detalleServidor.modeloServidor,
                    ModeloCPU: detalleServidor.modeloCPU,
                    NumCPU: detalleServidor.numCPU,
                    CapacidadMemoriaRAM : detalleServidor.capacidadMemoriaRAM ,
                    AlmacenamientoCPU: detalleServidor.almacenamientoCPU,
                    TarjetaRed: detalleServidor.tarjetaRed,
                    TarjetaVideo: detalleServidor.tarjetaVideo,
                    NET: detalleServidor.net,
                    SubNET: detalleServidor.subNET,
                    IpPublica: detalleServidor.ipPublica,
                    IpPrivada: detalleServidor.ipPrivada,
                    CodTipoOS: detalleServidor.codTipoOS,
                    Distribucion : detalleServidor.distribucion ,
                    Version : detalleServidor.version ,
                    Licencia : detalleServidor.licencia ,
                    URLAcceso: detalleServidor.urlAcceso,
                    UsuarioRoot: detalleServidor.usuarioRoot,
                    Contrasenia: detalleServidor.contrasenia,
                    PuertoRemoto: Number(detalleServidor.puertoRemoto),
                    CodProtocoloRemoto: detalleServidor.codProtocoloRemoto,
                    FechaInstalacion: detalleServidor.fechaInstalacion,
                    FechaUltimoMantenimiento: detalleServidor.fechaUltimoMantenimiento,
                })
            })
            
            notify((response.isValid ? response.content : response.exceptions[0].description), response.isValid ? 'success' : 'error');
            return response.isValid;
        }
        catch(e)
        {
            console.log('Error al guardar servidor: ',e)
            notify('Ocurrió un error en el servicio', 'error');
            return false;
        }
    }

    const eliminarServidor = async (codigo, motivo) => {
        try
        {
            const response = await Fetch({
                url: urlGestionConocimiento + '/Server',
                method: 'Delete',
                body: JSON.stringify({
                    CodUsuarioAccion: stateUser.codUsuario,
                    CodGestionInfraestructuraServidor: codigo,
                    MotivoEliminacion: motivo
                })
            });

            notify((response.isValid ? response.content : response.exceptions[0].description), response.isValid ? 'success' : 'error');
            return response.isValid;
        }
        catch(e)
        {
            notify('Ocurrió un error en el servicio', 'error');
            return false;
        }
    }

    const editarValorServidor = (key, value) => {
        setDetalleServidor(servidor => {
            return {
                ...servidor,
                [key]: value
            }
        })
    }

    const listarComboServidores = async () => {
        try
        {
            const response = await Fetch({ url: urlGestionConocimiento + '/Server/ServerList' });
            !response.isValid && notify(response.exceptions[0].description, 'error');
            setListaServidores(response.isValid ? response.content : []);
        }
        catch(e)
        {
            setListaServidores([]);
            notify('Ocurrió un error en el servicio', 'error');
            console.log('Error al listar servidores: ',e);
        }
    }

    //////////////////////////////////////////////////////////// END POINT PARA SERVICIOS  /////////////////////////////////////////////////////////////////////////
    
    const listarServiciosGeneral = async (codEstado) => {       
        try
        {
           const response = await Fetch({
                url: urlGestionConocimiento + '/Service?' + new URLSearchParams({
                    codEstado : codEstado
                })
            });
            !response.isValid && notify(response.exceptions[0].description);
            setServiciosGeneral(response.isValid ? response.content : []);
        }
        catch(e)
        {
            console.log('Error al listar serviciosGeneral/aplicaciones: ',e);
            setServiciosGeneral([]);
            notify('Ocurrió un error en el servicio', 'error');
        }
    }

    const listarDetalleServicio = async (servicio) => {
        try
        {
            if(servicio)
            {
                setDetalleServicio({
                    codGestionInfraestructuraAplicacion: servicio.codGestionInfraestructuraAplicacion,
                    codigoAplicacion: servicio.codigoAplicacion,
                    nomProyecto: servicio.nomProyecto,
                    nomAplicacion: servicio.nomAplicacion,
                    codTipoAplicacion: servicio.codTipoAplicacion,
                    nomTipoAplicacion: servicio.nomTipoAplicacion,
                    versionActual: servicio.versionActual,
                    usuarioPrincipal: servicio.usuarioPrincipal,
                    codLenguajeProgramacion: servicio.codLenguajeProgramacion,
                    nomLenguajeProgramacion: servicio.nomLenguajeProgramacion,
                    cuentaPropietario: servicio.cuentaPropietario,
                    repositorio: servicio.repositorio,
                    codTipoOS: servicio.codTipoOS,
                    nomTipoOS: servicio.nomTipoOS,
                    codPlataforma: servicio.codPlataforma,
                    nomPlataforma: servicio.nomPlataforma,
                    codFramework: servicio.codFramework,
                    framework: servicio.framework,
                    versionFramework: servicio.versionFramework,
                    nomServidor: servicio.nomServidor,
                    localizacionArchivo: servicio.localizacionArchivo,
                    codGestionInfraestructuraServidor: servicio.codGestionInfraestructuraServidor,
                    fechaUltimaActualizacion: servicio.fechaUltimaActualizacion,
                    descripcion: servicio.descripcion,
                    codEstado: servicio.codEstado,
                    nomEstado: servicio.nomEstado,
                    contacto: servicio.contacto,
                    observaciones: servicio.observaciones,
                    urlAcceso: servicio.urlAcceso,
                    fechaAlta: servicio.fechaAlta,
                    codAmbienteTrabajo: servicio.codAmbienteTrabajo,
                    ambiente: servicio.ambiente,
                    nomDependencia: servicio.nomDependencia,
                    codDominioJerarquia: servicio.codDominioJerarquia,
                    codGestionInfraestructuraDomAux: servicio.codGestionInfraestructuraDomAux,
                    nomDomAux: servicio.nomDomAux,
                    documentacion: servicio.documentacion,
                    codMotorBaseDatos: servicio.codMotorBaseDatos,
                    nomMotorBaseDatos: servicio.nomMotorBaseDatos,
                    manualUsuario: servicio.manualUsuario
                });
                return
            }
            setDetalleServicio(detalleServicioDefault);

        }
        catch(e)
        {
            setDetalleServicio(detalleServicioDefault);
            notify('Ocurrió un error en el servicio', 'error');
            console.log('Error al listar detalle servicio: ',e);
        }
    }

    const guardarServicio = async () => {
        try
        {
            const esGuardar = detalleServicio.codGestionInfraestructuraAplicacion === 0 ? true : false;
            const response = await Fetch({
                url: urlGestionConocimiento + '/Service',
                method: esGuardar ? 'POST' : 'PUT',
                body: JSON.stringify({
                    CodUsuarioAccion: stateUser.codUsuario,
                    ...(!esGuardar ?
                        { CodGestionInfraestructuraAplicacion: detalleServicio.codGestionInfraestructuraAplicacion }
                        : 
                        ''
                    ),
                    Nomproyecto: detalleServicio.nomProyecto,
                    NomAplicacion: detalleServicio.nomAplicacion,
                    CodTipoAplicacion: detalleServicio.codTipoAplicacion,
                    VersionActual: detalleServicio.versionActual,
                    Contacto: detalleServicio.contacto,
                    Descripcion: detalleServicio.descripcion,
                    Observaciones: detalleServicio.observaciones,

                    CodLenguajeProgramacion: detalleServicio.codLenguajeProgramacion,
                    CuentaPropietario: detalleServicio.cuentaPropietario,
                    Repositorio: detalleServicio.repositorio,

                    CodTipoOS: detalleServicio.codTipoOS,
                    CodPlataforma: detalleServicio.codPlataforma,
                    CodFramework: detalleServicio.codFramework,
                    VersionFramework: detalleServicio.versionFramework,
                    CodGestionInfraestructuraServidor: detalleServicio.codGestionInfraestructuraServidor,
                    UrlAcceso: detalleServicio.urlAcceso,
                    FechaAlta: detalleServicio.fechaAlta,
                    FechaUltimaActualizacion: detalleServicio.fechaUltimaActualizacion,
                    NomDependencia: detalleServicio.nomDependencia,
                    CodGestionInfraestructuraDomAux: detalleServicio.codGestionInfraestructuraDomAux,
                    CodDominioJerarquia: detalleServicio.codDominioJerarquia,
                    CodMotorBaseDatos: detalleServicio.codMotorBaseDatos,
                    ManualUsuario: detalleServicio.manualUsuario,
                    CodAmbienteTrabajo: detalleServicio.codAmbienteTrabajo,
                })
            })
            notify((response.isValid ? response.content : response.exceptions[0].description), (response.isValid ? 'success' : 'error'));
            return response.isValid
        }
        catch(e)
        {
            console.log('Error al guardar servicio: ',e)
            notify('Ocurrió un error en el servicio', 'error');
            return false
        }
    }

    const eliminarServicio = async (codigo, motivo) => {
        try
        {
            const response = await Fetch({
                url: urlGestionConocimiento + '/Service',
                method: 'Delete',
                body: JSON.stringify({
                    CodUsuarioAccion: stateUser.codUsuario,
                    CodGestionInfraestructuraServidor: codigo,
                    MotivoEliminacion: motivo
                })
            });

            notify((response.isValid ? response.content : response.exceptions[0].description), response.isValid ? 'success' : 'error');
            return response.isValid;
        }
        catch(e)
        {
            console.log('Error al eliminar servicio: ',e)
            notify('Ocurrió un error en el servicio', 'error');
            return false;
        }
    }

    const editarValorServicio = (key, value) => {
        setDetalleServicio(servicio => {
            return {
                ...servicio,
                [key]: value
            }
        })
    }

    const listarlistaPlataformaDespliegue = async () => {
        try
        {
            const response = await Fetch({ url: urlGestionConocimiento + '/Service/ListDeploymentPlatform' });
            !response.isValid && notify(response.exceptions[0].description, 'error');
            setListalistaPlataformaDespliegue(response.isValid ? response.content : []);
            
        }
        catch (e)
        {
            console.log('Error al listar serviciosGeneral/aplicaciones: ',e);
            setListalistaPlataformaDespliegue([]);
            notify('Ocurrió un error en el servicio', 'error');
        }
    }

    const listarMotorBaseDatos = async () => {
        try
        {
            const response = await Fetch({ url: urlGestionConocimiento + '/Service/DataBaseEngine'});
            !response.isValid && notify(response.exceptions[0].descripcion, 'error')
            setListaMotorBD(response.isValid ? response.content : []);
        }
        catch(e)
        {
            console.log('Error al listar motor de base datos: ',e);
            setListaMotorBD([]);
            notify('Ocurrió un error en el servicio', 'error');
        }
    }

    /////////////////////////////////////////////////////// END POINT LECCIONES Y APRENDIZAJE //////////////////////////////////////////////////////////////////////

    const listarLeccionesAprendizaje = async () => {
        try
        {
            const response = await Fetch({ url: urlGestionConocimiento + '/LessonLearning'});
            !response.isValid && notify(response.exceptions[0].description);
            setLecciones(response.isValid ? response.content : []);
        }
        catch(e)
        {
            console.log('Error al listar lecciones/aprendizaje: ',e);
            setLecciones([]);
            notify('Ocurrió un error en el servicio', 'error');
        }
    }

    const listarDetalleLeccion = async (leccion) => {
        try
        {
            if(leccion)
            {
                setDetalleLeccion({
                    codGestionConocimiento: leccion.codGestionConocimiento,
                    titulo: leccion.titulo,
                    autor: leccion.autor,
                    codGestionInfraestructuraAplicacion: leccion.codGestionInfraestructuraAplicacion,
                    descripcionSituacion: leccion.descripcionSituacion,
                    descripcionSolucion: leccion.descripcionSolucion,
                    recomendacion: leccion.recomendacion,
                    codImpacto: leccion.codImpacto,
                    codCategoriaConocimiento: leccion.codCategoriaConocimiento,
                    documentacion: leccion.documentacion,
                    etiqueta: leccion.etiqueta,
                    listaImagenesLesson: leccion.listaImagenesLesson,
                })
                return
            }
            setDetalleLeccion(detalleLeccionDefault)
        }
        catch(e)
        {
            console.log('Error al listar detalle leccion: ',e);
            notify('Ocurrió un error al listar detalle', 'error');
            setDetalleLeccion(detalleLeccionDefault)
        }

    }

    const guardarEditarLeccionesAprendizaje = async (urlImagen) => {
        try
        {
            const esGuardar = detalleLeccion.codGestionConocimiento === 0  ? true : false;
            const response = await Fetch({ 
                url: urlGestionConocimiento + '/LessonLearning',
                method: esGuardar ? 'POST' : 'PUT',
                body: JSON.stringify({
                    codUsuarioAccion: stateUser.codUsuario,
                    ...(!esGuardar ?
                        { codGestionConocimiento: detalleLeccion.codGestionConocimiento }
                        : 
                        ''
                    ),
                    titulo: detalleLeccion.titulo,
                    autor: stateUser.nomUsuario,
                    codGestionInfraestructuraAplicacion: detalleLeccion.codGestionInfraestructuraAplicacion,
                    descripcionSituacion: detalleLeccion.descripcionSituacion,
                    descripcionSolucion: detalleLeccion.descripcionSolucion,
                    recomendacion: detalleLeccion.recomendacion,
                    codCategoriaConocimiento: detalleLeccion.codCategoriaConocimiento,
                    codImpacto: detalleLeccion.codImpacto,
                    documentacion: detalleLeccion.documentacion,
                    etiqueta: detalleLeccion.etiqueta,
                    ...(esGuardar ?
                        { listaImagenesLesson: urlImagen.length > 0 ? urlImagen : [] }
                        : 
                        { listaImagenesEditLesson: urlImagen.length > 0 ? urlImagen : [] }
                    )
                })
            });
            notify((response.isValid ? response.content : response.exceptions[0].description), response.isValid ? 'success' : 'error');
            return response.isValid
        }
        catch(e)
        {
            console.log('Error al guardar leccion y aprendizaje: ',e);
            notify('Ocurrió un error en el servicio', 'error');
            return false;
        }
    }

    const editarValorLeccion = (key, value) => {
        setDetalleLeccion(leccion => {
            return {
                ...leccion,
                [key]: value
            }
        })
    }

    const eliminarLeccionAprendizaje = async (codGestionConocimiento, motivoEliminacion) => {
        try
        {
            const response = await Fetch({ 
                url: urlGestionConocimiento + '/LessonLearning',
                method: 'DELETE',
                body: JSON.stringify({
                    codUsuarioAccion: stateUser.codUsuario,
                    codGestionConocimiento: codGestionConocimiento,
                    motivo: motivoEliminacion,
                })
            });
            notify((response.isValid ? response.content : response.exceptions[0].description), response.isValid ? 'success' : 'error');
            return response.isValid
        }
        catch(e)
        {
            console.log('Error al guardar leccion y aprendizaje: ',e);
            notify('Ocurrió un error en el servicio', 'error');
            return false;
        }
    }

    ///////////////////////////////////////////////////////////// DOCUMENTACION TECNICA //////////////////////////////////////////////////////////////////////////
    
    const listarDocumentacionTecnica = async () => {
        try
        {
            const response = await Fetch({ url: urlGestionConocimiento + '/TechnicalDocumentation'});
            !response.isValid && notify(response.exceptions[0].description);
            setDocumentacionTecnica(response.isValid ? response.content : []);
        }
        catch(e)
        {
            notify('Ocurrió un error en el servicio', 'error');
            setDocumentacionTecnica([]);
            console.log('Error al listar documentación técnica : ',e);
        }
    }

    const listarDetalleDocumentacion = async (detalleDocumentacion) => {
        try
        {
            if(detalleDocumentacion)
            {
                setDetalleDocumentacion({
                    codDocumentoTecnico: detalleDocumentacion.codDocumentoTecnico,
                    titulo: detalleDocumentacion.titulo,
                    autor: detalleDocumentacion.autor,
                    fechaCreacion: detalleDocumentacion.fechaCreacion,
                    codGestionInfraestructuraAplicacion: detalleDocumentacion.codGestionInfraestructuraAplicacion,
                    nomAplicacion: detalleDocumentacion.nomAplicacion,
                    nomProyecto: detalleDocumentacion.nomProyecto,
                    nomDocumentoTecnicoTipo: detalleDocumentacion.nomDocumentoTecnicoTipo,
                    codDocumentoTecnicoTipo: detalleDocumentacion.codDocumentoTecnicoTipo,
                    nomNivelConfidencialidad: detalleDocumentacion.nomNivelConfidencialidad,
                    codNivelConfidencialidad: detalleDocumentacion.codNivelConfidencialidad,
                    urlDocumentacion: detalleDocumentacion.urlDocumentacion,
                    descripcion: detalleDocumentacion.descripcion,
                    observacion: detalleDocumentacion.observacion,
                    etiqueta: detalleDocumentacion.etiqueta,
                    fechaUltimaActualizacion: detalleDocumentacion.fechaUltimaActualizacion,
                    codEstado: detalleDocumentacion.codEstado,
                    nomEstado: detalleDocumentacion.nomEstado
                })
                return
            }
            setDetalleDocumentacion(detalleDocumentacionDefault)
        }
        catch(e)
        {
            notify('Ocurrió un error en el servicio', 'error');
            setDetalleDocumentacion(detalleDocumentacionDefault);
            console.log('Error al listar documentación técnica : ',e);
        }
    }

    const guardarEditarDocumentacion = async () => {
        console.log('detalleDocumentacion ',detalleDocumentacion)
        try
        {
            const esGuardar = detalleDocumentacion.codDocumentoTecnico == 0  ? true : false;
            const response = await Fetch({ 
                url: urlGestionConocimiento + '/TechnicalDocumentation',
                method: esGuardar ? 'POST' : 'PUT',
                body: JSON.stringify({
                    CodUsuarioAccion: stateUser.codUsuario,
                    ...(!esGuardar ?
                        { CodDocumentoTecnico: detalleDocumentacion.codDocumentoTecnico }
                        : 
                        ''
                    ),
                    Titulo: detalleDocumentacion.titulo,
                    Autor: stateUser.nomUsuario,
                    CodGestionInfraestructuraAplicacion: detalleDocumentacion.codGestionInfraestructuraAplicacion,
                    CodDocumentoTecnicoTipo: detalleDocumentacion.codDocumentoTecnicoTipo,
                    CodNivelConfidencialidad: detalleDocumentacion.codNivelConfidencialidad,
                    URLDocumentacion: detalleDocumentacion.urlDocumentacion,
                    Descripcion: detalleDocumentacion.descripcion,
                    Observacion: detalleDocumentacion.observacion,
                    Etiqueta: detalleDocumentacion.etiqueta
                })
            });
            notify((response.isValid ? response.content : response.exceptions[0].description), response.isValid ? 'success' : 'error');
            return response.isValid
        }
        catch(e)
        {
            console.log('Error al guardar leccion y aprendizaje: ',e);
            notify('Ocurrió un error en el servicio', 'error');
            return false;
        }
    }

    const editarValorDocumentacion = (key, value) => {
        setDetalleDocumentacion(doc => {
            return{
                ...doc,
                [key]: value
            }
        })
    }

    const eliminarDocumentacion = async (codDocumento, motivoEliminar) => {
        try
        {
            const response = await Fetch({
                url: urlGestionConocimiento + '/TechnicalDocumentation',
                method: 'DELETE',
                body:JSON.stringify({
                    CodUsuarioAccion: stateUser.codUsuario,
                    CodDocumentoTecnico: codDocumento,
                    MotivoEliminacion: motivoEliminar
                })
            })
            notify((response.isValid ? response.content: response.exceptions[0].description), response.isValid ? 'success' : 'error')
            return response.isValid

        }
        catch (e)
        {
            notify('Ocurrió un error en el servicio', 'error');
            console.log('Error al eliminar ')
            return false
        }
    }

    const listarTipoDocumentacion = async () => {
        try
        {
            const response = await Fetch({ url: urlGestionConocimiento + '/TechnicalDocumentation/Type'});
            !response.isValid && notify(response.exceptions[0].description);
            setListaTipoDocumentacion(response.isValid ? response.content : []);
        }
        catch(e)
        {
            notify('Ocurrió un error en el servicio', 'error');
            setListaTipoDocumentacion([]);
            console.log('Error al listar documentación técnica : ',e);
        }
    } 

    
    

    return{
        listarEstados,
        listaEstadoConocimiento,
        listarProveedorDominio,
        listaProveedorDominio,
        listarProveedorSSL,
        listaProveedorSSL,
        listarComboServidores,
        listaServidores,
        listarCategoriaConocimiento,
        listaCategoriaConocimiento,
        listarNivelImpacto,
        listaNivelesImpacto,
        listarServicios,
        listaServicio,
        listarDistritosLima,
        listDistritosLima,
        listarAmbienteTrabajo,
        listaAmbienteTrabajo,
        listarTipoServidor,
        listaTipoServidor,
        listarSistemaOperativo,
        listaSistemaOperativo,
        listarProtocoloRemoto,
        listaProtocoloRemoto,
        listarDominiosCombo,
        listaDominios,
        listarlistaPlataformaDespliegue,
        listaPlataformaDespliegue,
        listarFramework,
        listaFramework,


        listarDominios,
        dominios,
        listarDetalleDominio,
        detalleDominio,
        guadarEditarDominio,
        eliminarDominio,
        editarValorDominio,
        listarDominioSubdominio,
        listaDominioSubDom,

        listarSubDominios,
        subDominios,
        listarDetalleSubDominio,
        detalleSubDominio,
        guardarEditarSubdominio,
        eliminarSubDominio,
        editarValorSubDominio,


        listarServidores,
        servidores,
        listarDetalleServidor,
        detalleServidor,
        guardarEditarServidor,
        eliminarServidor,
        editarValorServidor,

        listarServiciosGeneral,
        serviciosGeneral,
        listarDetalleServicio,
        detalleServicio,
        guardarServicio,
        eliminarServicio,
        editarValorServicio,
        listarTipoServicios,
        listaTipoServicios,
        listarLenguajeProgramacion,
        listaLenguajeProgramacion,
        listarMotorBaseDatos,
        listaMotorBD,

        listarLeccionesAprendizaje,
        lecciones,
        listarDetalleLeccion,
        detalleLeccion,
        editarValorLeccion,
        guardarEditarLeccionesAprendizaje,
        eliminarLeccionAprendizaje,
        
        listarDocumentacionTecnica,
        documentacionesTecnica,
        listarDetalleDocumentacion,
        detalleDocumentacion,
        listarTipoDocumentacion,
        listaTipoDocumentacion,
        listarNivelConfidencialidad,
        listaNivelConfidencialidad,
        editarValorDocumentacion,
        guardarEditarDocumentacion,
        eliminarDocumentacion,


    }
}